import {$api} from "@/services";


export default function(store) {
    try {
      store.$api = $api;
    } catch (e) {
      console.error(e);
    }
}